module.exports = __webpack_public_path__ + "assets/img/check-circle.4d2d2a4f.svg";